import { render, staticRenderFns } from "./DetectionSummaryLabel.vue?vue&type=template&id=a1096c7e&scoped=true"
import script from "./DetectionSummaryLabel.vue?vue&type=script&lang=js"
export * from "./DetectionSummaryLabel.vue?vue&type=script&lang=js"
import style0 from "./DetectionSummaryLabel.vue?vue&type=style&index=0&id=a1096c7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1096c7e",
  null
  
)

export default component.exports